// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-comment-add {
  margin-top: 16px;
  display: block;
}
.fi-comment-add .fi-text-editor .fi-contenteditable > div {
  min-height: 114px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-comments/fi-comments-list/fi-comment-add/fi-comment-add.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;AACJ;AACI;EACI,iBAAA;AACR","sourcesContent":[".fi-comment-add {\r\n    margin-top: 16px;\r\n    display: block;\r\n\r\n    .fi-text-editor .fi-contenteditable > div {\r\n        min-height: 114px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
